import * as React from "react";
import { ICurrentRoute } from "src/modules/Routing/types";

type CurrentRouteContextType = [ICurrentRoute, React.Dispatch<React.SetStateAction<ICurrentRoute>>]
const CurrentRouteContext = React.createContext([] as any as CurrentRouteContextType);

const CurrentRouteProvider = ({ children }) => {
  const stateDispatch = React.useState<ICurrentRoute>({
    showNavBar: false,
    path: [''],
  });
  return (
    <CurrentRouteContext.Provider value={stateDispatch}>
      {children}
    </CurrentRouteContext.Provider>
  )
}
export {
  CurrentRouteContext,
  CurrentRouteProvider,
};


// WEBPACK FOOTER //
// ./src/modules/Routing/auth/CurrentRouteContext.tsx